export const ROOM_TYPES = {
  CREW: 1,
  SINGLE: 2,
  GROUP: 3,
};
